import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography
} from '@mui/material';
  
  import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import StorefrontIcon from '@mui/icons-material/Storefront';
  
import { useCallback, useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ErrorScreen, Loading } from "../../../components";
import { useToastStore, useUserStore } from '../../../stores';
import { colorSubText, textFieldStyle } from '../../../theme';
import { SubmitButton } from '../../company/components/ButtonComponent';
import { AtualizarDadosLojistaDto, DadosContaLojistaDto } from '../dto/ShopkeeperDTO';
import { atualizarDadosLojista, fetchDadosLojista } from '../repository/ShopkeeperRepository';

export function DadosLojistaTab() {
  const {user} = useUserStore();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const { setToast } = useToastStore();
    const jaCarregou = useRef(false);
    const {
      handleSubmit,
      reset,
      control,
    } = useForm<DadosContaLojistaDto>({ defaultValues: {
        nome_completo: null,
        email_usuario: null,
        telefone_usuario: null,
        razao_social: null,
        fantasia: null,
        email_loja: null,
        telefone_loja: null,
        celular_loja: null,
        cep: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        uf: null,
        documento: null,
        },});


const fetchDados = useCallback(async () => {
  try {
    const result = await fetchDadosLojista();
    if(!result.success) {
      setToast({variant:"error", message: result.message});
      return;
    }
    reset({
      bairro: result.data.bairro,
      cidade: result.data.cidade,
      uf: result.data.uf,
      cep: result.data.cep,
      logradouro: result.data.logradouro,
      numero: result.data.numero,
      complemento: result.data.complemento,
      celular_loja: result.data.celular_loja,
      email_loja: result.data.email_loja,
      telefone_loja: result.data.telefone_loja,
      razao_social: result.data.razao_social,
      fantasia: result.data.fantasia,
      email_usuario: result.data.email_usuario,
      telefone_usuario: result.data.telefone_usuario,
      nome_completo: result.data.nome_completo,
      documento: result.data.documento,
    });
  } catch (error) {
    setToast({variant:"error", message: "Erro. Contate o administrador."});
  }
}, [setToast]);

const onSubmit = async (data: AtualizarDadosLojistaDto) => {
  try {
    setIsLoading(true);
    const payload : AtualizarDadosLojistaDto = {
      nome_completo: data.nome_completo,
      email_usuario: data.email_usuario,
      telefone_usuario: data.telefone_usuario,
      razao_social: data.razao_social,
      fantasia: data.fantasia,
      email_loja: data.email_loja,
      telefone_loja: data.telefone_loja,
      celular_loja: data.celular_loja,
      cep: data.cep,
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
    };
    const result = await atualizarDadosLojista(payload);
    if(!result.success) {
      setToast({variant:"error", message: result.message});
      return;
    }
    setToast({variant:"success", message: result.message});
  } catch (error) {
    setToast({variant:"error", message: "Erro. Contate o administrador."});
  } finally { 
    setIsLoading(false);
  }
}


  useEffect(()=> {
    const preLoadData = async ()=> {
      if(jaCarregou.current) return;
      jaCarregou.current = true;
      setIsLoading(true);
      await fetchDados();
      setIsLoading(false);
    }
    preLoadData();
  },[user, fetchDados]);


    if(isLoading) return <Loading  fullScreen={true}/>
    if(error) return <ErrorScreen fullScreen={true}/>

    return (
        <Box display={"flex"} flexDirection={"column"}>
            <Typography fontSize={"1.535rem"} fontWeight={700}>Configurações da Conta</Typography>
            <Typography fontSize={"1.335rem"} fontWeight={400} color={colorSubText}>Gerencie suas informações pessoais e os dados da sua loja.</Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
            <Box display="flex" flexDirection="column" gap={4} mt={4} >  
          {/* ===================== DADOS PESSOAIS ===================== */}
          <Card variant="outlined"       
            sx={{
            bgcolor: "background.paper",
            borderRadius: 4,
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            border: "1px solid",
            borderColor: "divider",
            }}>
            <CardHeader
              avatar={<AccountCircleIcon color="primary" />}
              title={
                <Typography fontWeight={600} fontSize={18}>
                  Dados Pessoais
                </Typography>
              }
            />
    
            <Divider />
    
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                <Controller
                    name="nome_completo"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Nome Completo"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={6}>
                <Controller
                    name="email_usuario"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Login / E-mail"
                        type="email"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={6}>
                <Controller
                    name="telefone_usuario"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Telefone"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
    
          {/* ===================== INFORMAÇÕES DA LOJA ===================== */}
          <Card variant="outlined"
           sx={{
            bgcolor: "background.paper",
            borderRadius: 4,
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            border: "1px solid",
            borderColor: "divider",
            }}>
            <CardHeader
              avatar={<StorefrontIcon color="primary" />}
              title={
                <Typography fontWeight={600} fontSize={18}>
                  Informações da Loja
                </Typography>
              }
            />
    
            <Divider />
    
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                <Controller
                  name="razao_social"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      label="Razão Social"
                      value={field.value ?? ''}
                      sx={textFieldStyle}
                    />
                  )}
                />
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Controller
                    name="fantasia"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Nome Fantasia"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={6}>
                  <Controller
                    name="documento"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        disabled={true}
                        fullWidth
                        label="CNPJ"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={6}>
                <Controller
                    name="email_loja"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="E-mail da Loja"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={6}>
                <Controller
                    name="telefone_loja"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Telefone Fixo"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={6}>
                <Controller
                    name="celular_loja"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Celular"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
              </Grid>
    
              {/* Divider Endereço */}
              <Box my={4} position="relative">
                <Divider />
                <Box
                  position="absolute"
                  top="50%"
                  left="50%"
                  sx={{
                    transform: 'translate(-50%, -50%)',
                    px: 2,
                    bgcolor: 'background.paper',
                  }}
                >
                  <Typography
                    variant="caption"
                    fontWeight={600}
                    letterSpacing={1.5}
                    color="text.secondary"
                  >
                    ENDEREÇO
                  </Typography>
                </Box>
              </Box>
    
              {/* Endereço */}
              <Grid container spacing={3}>
                <Grid item xs={12} md={3}>
                <Controller
                    name="cep"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Cep"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={9}>
                <Controller
                    name="logradouro"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Logradouro"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={3}>
                <Controller
                    name="numero"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Número"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={9}>
                <Controller
                    name="complemento"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Complemento"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={5}>
                <Controller
                    name="bairro"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Bairro"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={5}>
                <Controller
                    name="cidade"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Cidade"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} md={2}>
                <Controller
                    name="uf"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Estado"
                        value={field.value ?? ''}
                        sx={textFieldStyle}
                      />
                    )}
                  />
                </Grid>
    
                <Grid item xs={12} display="flex" justifyContent="flex-end">
                 <SubmitButton title="Salvar"/>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
            </form>
        </Box>
      );

}